package com.eladfinish.bible.contest.screens.search.usecases.specialSearch

import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.splitByRegex
import com.eladfinish.bible.contest.screens.search.model.ChapterDetails

/**
 * Developed by
 * @author Elad Finish
 */

/**
 * how many verses contain N words?
 * expected output:
 * there are 142 verses which contain 3 words
 * there are 198 verses which contain 4 words
 * there are 700 verses which contain 5 words
 * there are 1594 verses which contain 6 words
 */

class WordCounter(private val includeLog: Boolean = false) : SpecialSearch {

    private val sb = StringBuilder()

    private val numberMap = mutableMapOf<Int, Int>()

    override fun process(chapterDetails: ChapterDetails) = with(chapterDetails) {
        val mapPerChapter = mutableMapOf<Int, Int>()
        verses.forEach { verse ->
            verse.trim().splitByRegex(StringConstants.REGEX_SPACE).size.let { numberOfWords ->
                numberMap[numberOfWords] = numberMap[numberOfWords]?.plus(1) ?: 1
                mapPerChapter[numberOfWords] = mapPerChapter[numberOfWords]?.plus(1) ?: 1
            }
        }

        if (includeLog) {
            sb.append(bookName).append(" ")
                .append(chapterName).append(" - ")
                .append(verses.size).append(" פסוקים ")
                .append(mapPerChapter.toString())
                .append("\n")
        }
    }

    override fun getSummary(): String {
        return sb.apply {
            if (includeLog) {
                append("\n@@@\n")
            }
            append("סיכום - מספר מילים X: מספר הפסוקים שמכילים X מילים").append("\n")
            numberMap
                .toList()
                .sortedBy { it.first }
                .forEach { (key, value) ->
                    append("• מספר הפסוקים עם ").append(key).append(" מילים הוא ").append(value).append("\n")
                }
        }.toString()
    }

}
